import { render, staticRenderFns } from "./Cargo.vue?vue&type=template&id=107f71b7&scoped=true"
import script from "./Cargo.vue?vue&type=script&lang=js"
export * from "./Cargo.vue?vue&type=script&lang=js"
import style0 from "./Cargo.vue?vue&type=style&index=0&id=107f71b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f71b7",
  null
  
)

export default component.exports